import cuid from 'cuid'
import { createReducer } from 'redux-create-reducer'
import {
  CAMPAIGN_LIST_BEGIN_EDIT,
  CAMPAIGN_RECIPIENT_ADD,
  CAMPAIGN_RECIPIENT_CHANGE,
  CAMPAIGN_RECIPIENT_MODE_SELECT,
  CAMPAIGN_RECIPIENT_REMOVE,
} from '@disco/constants/ActionTypes'
export type MatchMode = 'all' | 'any'
export type RuleOp = 'equals' | 'notEquals' | 'contains' | 'notContains'
export type RecipientRule = {
  id: string
  ruleOp: RuleOp
  ruleType: string
  ruleValue: string
}
export type State = {
  matchMode: MatchMode
  rules: Array<RecipientRule>
}
const initialState: State = {
  matchMode: 'all',
  rules: [
    {
      id: 'default1',
      ruleOp: 'contains',
      ruleType: 'mailingList',
      ruleValue: '',
    },
  ],
}
export const recipientRulesReducer = createReducer<State, any>(initialState, {
  [CAMPAIGN_LIST_BEGIN_EDIT](_state, { recipientRules }) {
    return recipientRules || initialState // full overwrite
  },

  [CAMPAIGN_RECIPIENT_MODE_SELECT](state, action) {
    return { ...state, matchMode: action.matchMode }
  },

  [CAMPAIGN_RECIPIENT_ADD](state, action) {
    return {
      ...state,
      rules: state.rules.concat({
        ruleType: action.ruleType,
        ruleOp: 'contains',
        ruleValue: '',
        id: cuid(),
      }),
    }
  },

  [CAMPAIGN_RECIPIENT_REMOVE](state, action) {
    return { ...state, rules: state.rules.filter(r => r.id !== action.ruleId) }
  },

  [CAMPAIGN_RECIPIENT_CHANGE](state, action) {
    const idx = state.rules.findIndex(r => r.id === action.ruleId)
    if (idx === -1) return state
    return {
      ...state,
      rules: [
        ...state.rules.slice(0, idx),
        { ...state.rules[idx], ...action.updated },
        ...state.rules.slice(idx + 1),
      ],
    }
  },
})
